import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { InputX } from 'components'
import styles from './index.module.css'
import DetailTip from 'views/mydata/common/DetailTip';

const HomeSearch1 = () => {

	const App = useApp()
	const [showLayer, setShowLayer] = useState(false)

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding">
				<div className="flex-align_center">
					<div className={styles["home-title"]}>내 부동산 주소를 찾아주세요.</div>
					<i className="icon icon_question ml_10" onClick={openLayer} />
				</div>
				<div className="mt_10">
					<i className="tag tag-box tag-gray normal">아파트</i>
				</div>
				<div className="form-group search-bar mt_30">
					<InputX type="text" placeholder="예) 판교역로 234, 분당 주공, 삼평동 681" id="" />
					<i className="icon icon_search" />
				</div>
			</div>

			<DetailTip show={showLayer} closeLayer={closeLayer}>
				혹시 거주하시는 부동산이 검색되지 않나요?
				최근 6개월 내에 실거래가 일어나지 않은 부동산은
				검색이 되지 않아요.
				모니 부동산은 국토교통부 실거래가 API를 활용하여
				아파트, 오피스텔 및 연립/다세대 정보를 제공하고 있어요.
			</DetailTip>
		</div>
	)
}

export default HomeSearch1